import { useEffect } from 'react';

export default function Terms() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-[#0A0A0A]">
      {/* Header */}
      <header className="bg-[#1A1A1A] border-b border-gray-800 sticky top-0 z-50">
        <div className="max-w-[1200px] mx-auto px-6 py-4">
          <a href="/" className="inline-flex items-center gap-2 hover:opacity-80 transition-opacity">
            <div className="flex flex-col leading-none">
              <span className="text-[20px] font-bold text-white">LEXO</span>
              <span className="text-[11px] text-gray-400 tracking-wide">강한 일본어</span>
            </div>
          </a>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-[1000px] mx-auto px-6 py-12 md:py-20">
        <div className="bg-[#1A1A1A] border border-gray-800 rounded-2xl p-8 md:p-12">
          <h1 className="text-3xl md:text-4xl font-bold text-white mb-4">이용약관</h1>
          <p className="text-sm text-gray-400 mb-12">시행일자: 2026년 3월 1일</p>

          <div className="space-y-10 text-gray-300">
            {/* 제1조 */}
            <section>
              <h2 className="text-xl font-semibold text-white mb-4">제1조 (목적)</h2>
              <p className="leading-relaxed">
                본 약관은 LEXO(이하 "회사")가 제공하는 일본어 교육 서비스(이하 "서비스")의 이용과 관련하여 회사와 이용자 간의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.
              </p>
            </section>

            {/* 제2조 */}
            <section>
              <h2 className="text-xl font-semibold text-white mb-4">제2조 (용어의 정의)</h2>
              <div className="space-y-3 leading-relaxed">
                <p>① 본 약관에서 사용하는 용어의 정의는 다음과 같습니다:</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li><strong className="text-white">"서비스"</strong>란 회사가 제공하는 일본어 교육 콘텐츠, 강의, 학습 자료 및 관련 부가 서비스를 의미합니다.</li>
                  <li><strong className="text-white">"이용자"</strong>란 본 약관에 따라 회사가 제공하는 서비스를 이용하는 회원 및 비회원을 말합니다.</li>
                  <li><strong className="text-white">"회원"</strong>이란 회사와 서비스 이용계약을 체결하고 회원 자격을 부여받은 자를 말합니다.</li>
                  <li><strong className="text-white">"콘텐츠"</strong>란 회사가 제공하는 강의 영상, 교재, 학습 자료 등 일체의 정보를 의미합니다.</li>
                </ul>
                <p>② 본 조에서 정의되지 않은 용어는 관련 법령 및 서비스별 안내에서 정하는 바에 따릅니다.</p>
              </div>
            </section>

            {/* 제3조 */}
            <section>
              <h2 className="text-xl font-semibold text-white mb-4">제3조 (약관의 효력 및 변경)</h2>
              <div className="space-y-3 leading-relaxed">
                <p>① 본 약관은 서비스 화면에 게시하거나 기타의 방법으로 공지함으로써 효력이 발생합니다.</p>
                <p>② 회사는 필요한 경우 관련 법령을 위배하지 않는 범위에서 본 약관을 변경할 수 있으며, 약관이 변경되는 경우 변경사항을 시행일자 7일 전부터 공지합니다.</p>
                <p>③ 이용자가 변경된 약관에 동의하지 않는 경우, 서비스 이용을 중단하고 이용계약을 해지할 수 있습니다. 변경된 약관의 효력 발생일 이후에도 서비스를 계속 이용하는 경우에는 약관 변경에 동의한 것으로 간주합니다.</p>
              </div>
            </section>

            {/* 제4조 */}
            <section>
              <h2 className="text-xl font-semibold text-white mb-4">제4조 (서비스 이용계약)</h2>
              <div className="space-y-3 leading-relaxed">
                <p>① 이용계약은 이용자가 본 약관에 동의하고 회사가 정한 절차에 따라 서비스 이용 신청을 하며, 회사가 이를 승낙함으로써 체결됩니다.</p>
                <p>② 회사는 다음 각 호에 해당하는 경우 이용 신청을 승낙하지 않거나 사후에 이용계약을 해지할 수 있습니다:</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>타인의 명의를 도용하여 신청한 경우</li>
                  <li>허위 정보를 기재하거나 회사가 요구하는 내용을 기재하지 않은 경우</li>
                  <li>관련 법령 또는 본 약관을 위반하여 신청하는 경우</li>
                  <li>기타 회사가 합리적인 판단에 의하여 필요하다고 인정하는 경우</li>
                </ul>
              </div>
            </section>

            {/* 제5조 */}
            <section>
              <h2 className="text-xl font-semibold text-white mb-4">제5조 (서비스 이용료 및 결제)</h2>
              <div className="space-y-3 leading-relaxed">
                <p>① 회사가 제공하는 서비스는 기본적으로 유료이며, 각 서비스의 이용료는 서비스 안내 페이지에 명시됩니다.</p>
                <p>② 이용자는 신용카드, 계좌이체, 간편결제 등 회사가 제공하는 결제 수단을 통해 이용료를 결제할 수 있습니다.</p>
                <p>③ 결제 완료 후 서비스 이용 권한이 부여되며, 결제 관련 영수증은 이메일 또는 서비스 내에서 확인할 수 있습니다.</p>
                <p>④ 이용료는 부가가치세를 포함한 금액이며, 결제 시점의 가격이 적용됩니다.</p>
              </div>
            </section>

            {/* 제6조 */}
            <section>
              <h2 className="text-xl font-semibold text-white mb-4">제6조 (환불 정책)</h2>
              <div className="space-y-3 leading-relaxed">
                <p>① 회사는 전자상거래 등에서의 소비자보호에 관한 법률 등 관련 법령에 따라 환불을 처리합니다.</p>
                <p>② 다음 각 호의 경우 환불이 가능합니다:</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>서비스 이용 개시 전: 전액 환불</li>
                  <li>서비스 이용 개시 후 7일 이내이며 콘텐츠 이용률이 10% 미만인 경우: 전액 환불</li>
                  <li>서비스 이용 개시 후 7일 이내이며 콘텐츠 이용률이 10% 이상인 경우: 부분 환불 (이용 기간 및 이용률에 따라 차등 적용)</li>
                </ul>
                <p>③ <strong className="text-white">콘텐츠 이용 여부의 판단 기준</strong>은 다음과 같습니다:</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>발송된 콘텐츠(카카오톡 메시지)의 <strong className="text-white">읽음 여부</strong>를 기준으로 판단합니다.</li>
                  <li>카카오톡 읽음 확인이 된 콘텐츠는 이용한 것으로 간주합니다.</li>
                </ul>
                <p>④ 다음 각 호의 경우 환불이 제한될 수 있습니다:</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>이용자의 귀책사유로 서비스 이용이 불가능한 경우</li>
                  <li>할인 또는 프로모션을 통해 구매한 경우 (별도 환불 정책 적용)</li>
                  <li>서비스 이용 개시 후 7일이 경과한 경우</li>
                </ul>
                <p>⑤ 다음 항목은 환불 대상에서 제외됩니다:</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li><strong className="text-white">카드 수수료:</strong> 신용카드 및 간편결제 이용 시 발생하는 결제 수수료는 환불되지 않습니다.</li>
                  <li><strong className="text-white">부가가치세(VAT):</strong> 결제 금액에 포함된 부가세는 환불되지 않습니다.</li>
                  <li><strong className="text-white">환불 수속 수수료:</strong> 환불 처리 과정에서 발생하는 수속 수수료는 환불되지 않습니다.</li>
                </ul>

                {/* 환불 신청 방법 */}
                <p className="pt-2">⑥ <strong className="text-white">환불 신청 방법</strong>은 다음과 같습니다:</p>
                <div className="ml-4 bg-[#111111] border border-gray-700 rounded-xl p-5 space-y-3">
                  <p className="text-white font-medium">📧 이메일 신청 (권장)</p>
                  <ul className="list-disc list-inside space-y-2 ml-2">
                    <li>신청 이메일: <a href="mailto:lexojp.help@gmail.com" className="text-[#14B8A6] hover:text-[#10a896] transition-colors">lexojp.help@gmail.com</a></li>
                    <li>제목 형식: <strong className="text-white">[환불 신청] 성함 + 결제일</strong> (예: [환불 신청] 홍길동 2025-01-15)</li>
                    <li>본문 필수 기재 항목: 성함, 연락처(카카오톡 ID 또는 전화번호), 결제일, 결제 금액, 환불 사유</li>
                  </ul>
                  <p className="text-gray-400 text-sm">※ 이메일 접수 후 확인 회신이 없을 경우, 동일 내용으로 재발송해 주시기 바랍니다.</p>
                </div>

                {/* 환불 처리 기간 */}
                <p className="pt-2">⑦ <strong className="text-white">환불 처리 기간</strong>은 다음과 같습니다:</p>
                <div className="ml-4 bg-[#111111] border border-gray-700 rounded-xl p-5 space-y-3">
                  <ul className="list-disc list-inside space-y-2">
                    <li>환불 신청 접수 후 <strong className="text-white">영업일 기준 3일 이내</strong>에 환불 가능 여부를 안내해 드립니다.</li>
                    <li>환불 승인 후 실제 환불 완료까지는 결제 수단에 따라 <strong className="text-white">3~7 영업일</strong>이 소요될 수 있습니다.</li>
                    <li>카드 결제의 경우, 카드사 처리 일정에 따라 환불 반영 시점이 다를 수 있습니다.</li>
                    <li>계좌이체 환불 시, 신청 시 기재한 계좌 정보로 입금됩니다.</li>
                  </ul>
                  <p className="text-gray-400 text-sm">※ 영업일은 주말 및 공휴일을 제외한 평일(월~금)을 기준으로 합니다.</p>
                </div>

                {/* 고객센터 안내 */}
                <p className="pt-2">⑧ <strong className="text-white">고객센터 안내</strong></p>
                <div className="ml-4 bg-[#111111] border border-gray-700 rounded-xl p-5 space-y-3">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <p className="text-white font-medium mb-2">📬 문의 채널</p>
                      <ul className="space-y-1 text-sm">
                        <li>이메일: <a href="mailto:lexojp.help@gmail.com" className="text-[#14B8A6] hover:text-[#10a896] transition-colors">lexojp.help@gmail.com</a></li>
                      </ul>
                    </div>
                    <div>
                      <p className="text-white font-medium mb-2">🕐 운영 시간</p>
                      <ul className="space-y-1 text-sm">
                        <li>평일(월~금): 오전 10:00 ~ 오후 6:00</li>
                        <li>점심시간: 오후 12:00 ~ 오후 1:00</li>
                        <li className="text-gray-400">※ 주말 및 공휴일 휴무</li>
                      </ul>
                    </div>
                  </div>
                  <p className="text-gray-400 text-sm border-t border-gray-700 pt-3">
                    ※ 운영 시간 외 접수된 문의는 다음 영업일에 순차적으로 처리됩니다.<br />
                    ※ 문의량이 많을 경우 답변이 지연될 수 있으며, 이 경우 별도 안내를 드립니다.
                  </p>
                </div>
              </div>
            </section>

            {/* 제7조 */}
            <section>
              <h2 className="text-xl font-semibold text-white mb-4">제7조 (이용자의 의무)</h2>
              <div className="space-y-3 leading-relaxed">
                <p>① 이용자는 다음 각 호의 행위를 하여서는 안 됩니다:</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>회원가입 신청 또는 변경 시 허위 내용을 등록하는 행위</li>
                  <li>타인의 정보를 도용하는 행위</li>
                  <li>회사가 제공하는 콘텐츠를 무단으로 복제, 배포, 전송하는 행위</li>
                  <li>회사의 서비스 운영을 고의로 방해하는 행위</li>
                  <li>타인의 명예를 손상시키거나 불이익을 주는 행위</li>
                  <li>관련 법령 또는 본 약관을 위반하는 행위</li>
                </ul>
                <p>② 이용자는 본 약관 및 관련 법령을 준수하여야 하며, 이를 위반하여 발생한 모든 책임은 이용자에게 있습니다.</p>
              </div>
            </section>

            {/* 제8조 */}
            <section>
              <h2 className="text-xl font-semibold text-white mb-4">제8조 (서비스 제공자의 의무)</h2>
              <div className="space-y-3 leading-relaxed">
                <p>① 회사는 관련 법령과 본 약관을 준수하며, 계속적이고 안정적인 서비스 제공을 위해 최선을 다합니다.</p>
                <p>② 회사는 이용자의 개인정보 보호를 위해 개인정보처리방침을 수립하고 이를 준수합니다.</p>
                <p>③ 회사는 서비스 이용과 관련하여 이용자로부터 제기된 의견이나 불만이 정당하다고 인정할 경우 이를 처리하여야 하며, 처리 과정 및 결과를 이용자에게 알립니다.</p>
                <p>④ 회사는 천재지변, 시스템 장애 등 불가항력적인 사유로 서비스를 제공할 수 없는 경우 이를 지체 없이 공지합니다.</p>
              </div>
            </section>

            {/* 제9조 */}
            <section>
              <h2 className="text-xl font-semibold text-white mb-4">제9조 (면책조항)</h2>
              <div className="space-y-3 leading-relaxed">
                <p>① 회사는 천재지변, 전쟁, 기간통신사업자의 서비스 중지 등 불가항력적인 사유로 서비스를 제공할 수 없는 경우 책임이 면제됩니다.</p>
                <p>② 회사는 이용자의 귀책사유로 인한 서비스 이용 장애에 대하여 책임을 지지 않습니다.</p>
                <p>③ 회사는 이용자가 서비스를 이용하여 기대하는 학습 효과나 결과에 대해 보증하지 않으며, 이에 대한 책임을 지지 않습니다.</p>
                <p>④ 회사는 이용자 간 또는 이용자와 제3자 간에 서비스를 매개로 발생한 분쟁에 대해 개입할 의무가 없으며, 이로 인한 손해를 배상할 책임을 지지 않습니다.</p>
              </div>
            </section>

            {/* 제10조 */}
            <section>
              <h2 className="text-xl font-semibold text-white mb-4">제10조 (분쟁해결 및 준거법)</h2>
              <div className="space-y-3 leading-relaxed">
                <p>① 회사와 이용자 간 발생한 분쟁에 관한 소송은 민사소송법상의 관할법원에 제기합니다.</p>
                <p>② 회사와 이용자 간 제기된 소송에는 대한민국 법을 적용합니다.</p>
              </div>
            </section>

            {/* 부칙 */}
            <section className="pt-8 border-t border-gray-800">
              <h2 className="text-xl font-semibold text-white mb-4">부칙</h2>
              <div className="space-y-3 leading-relaxed">
                <p>본 약관은 2026년 3월 1일부터 시행됩니다.</p>
              </div>
            </section>

            {/* 사업자 정보 */}
            <section className="pt-8 border-t border-gray-800">
              <h2 className="text-xl font-semibold text-white mb-4">사업자 정보</h2>
              <div className="space-y-2 leading-relaxed">
                <p><strong className="text-white">상호:</strong> LEXO (렉소)</p>
                <p><strong className="text-white">사업자등록번호:</strong> 572-62-00804</p>
                <p><strong className="text-white">이메일:</strong> <a href="mailto:lexojp.help@gmail.com" className="text-[#14B8A6] hover:text-[#10a896] transition-colors">lexojp.help@gmail.com</a></p>
              </div>
            </section>
          </div>
        </div>

        {/* Back Button */}
        <div className="mt-8 text-center">
          <a 
            href="/" 
            className="inline-flex items-center gap-2 text-[#14B8A6] hover:text-[#10a896] transition-colors text-sm font-medium"
          >
            <i className="ri-arrow-left-line"></i>
            홈으로 돌아가기
          </a>
        </div>
      </main>
    </div>
  );
}